import { fromAbsolute, getLocalTimeZone, now } from '@internationalized/date';
import { useMemo } from 'react';

export const useIsWithinTimeRange = ({ startTime, endTime }: { startTime?: number; endTime?: number }) =>
  useMemo(() => {
    if (!startTime) return false;

    const timezone = getLocalTimeZone();
    const currentTime = now(timezone).set({ second: 0, millisecond: 0 });
    const startDateTime = fromAbsolute(startTime, timezone);
    const endDateTime = fromAbsolute(endTime, timezone);

    if (startTime && endTime) {
      return currentTime.compare(startDateTime) >= 0 && currentTime.compare(endDateTime) <= 0;
    }

    if (startTime) {
      return currentTime.compare(startDateTime) >= 0;
    }

    return false;
  }, [endTime, startTime]);
